import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule }
	from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

import { pageTransitions } from '../../../../../shared/animations/page-transitions';
import { UserNotifications }
	from '../../../../models/v2/user-notifications';

@Component({
	selector: 'copo-dialog-remove-notification',
	templateUrl: './dialog-remove-notification.component.html',
	styleUrl: './dialog-remove-notification.component.css',
	animations: pageTransitions,
	encapsulation: ViewEncapsulation.Emulated,
	imports: [

		MatDialogModule,
		TranslateModule,

		MatButtonModule,
	],
})
export class DialogRemoveNotificationComponent implements OnInit {
	constructor(

		@Inject(MAT_DIALOG_DATA) public notification: UserNotifications,

		private readonly dialogRef: MatDialogRef<DialogRemoveNotificationComponent>,
	) {}

	ngOnInit() {
		this.dialogRef.updateSize('50%');
		this.dialogRef.disableClose = true;
	}

	cancel() {
		this.dialogRef.close(false);
	}

	validate() {
		this.dialogRef.close(true);
	}
}
